import { AxiosRequestConfig } from "axios/index";
import {
  Document,
  DocumentsResponseSchema,
  DocumentSchema,
  getDocumentsEndpoint,
  getSubContractorDocumentEndpoint,
  http,
} from "@/services";

export const requestDocumentsByApplicationId = (
  {
    email,
    requestId,
    getFilesAsBase64,
  }: { email: string; requestId: string | number; getFilesAsBase64?: boolean },
  config?: AxiosRequestConfig,
) => {
  return http.get<Document[]>(
    getDocumentsEndpoint,
    { email, requestId: `${requestId}`, getFilesAsBase64 },
    config,
    undefined,
    DocumentsResponseSchema,
  );
};

export const requestDocumentBySubcontractorId = (
  { subcontractorId }: { subcontractorId: string },
  config?: AxiosRequestConfig,
) => {
  return http.get<Document>(
    getSubContractorDocumentEndpoint,
    { subcontractorId },
    config,
    undefined,
    DocumentSchema,
  );
};
